// extracted by mini-css-extract-plugin
export default {"medium-header":"MediumHeader_medium-header__tHdFp"};